import queryString from 'query-string';
import MollieBatchConfirmationRequest from 'src/adminPanel/entities/offsetting/mollieBatch/MollieBatchConfirmationRequest';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import callApi, { CallApiResult } from '.';

export const getMollieBatches = (
    pageable: PageableQueryParams,
    settlementId: any,
    confirmedState: any
): Promise<CallApiResult> => {
    let query = queryString.stringify(
        {
            ...pageable,
            settlementId: settlementId || undefined,
            confirmedState: confirmedState !== null || confirmedState != undefined ? confirmedState : undefined,
        },
        { skipEmpty: true, skipNull: true }
    );
    if (query !== '') query = '?' + query;
    return callApi(`/api/batch/mollie/list${query}`);
};

export const getMollieSettlementOrders = (settlementId: string): Promise<CallApiResult> => {
    return callApi(`/api/batch/mollie/settlement-orders?settlementId=${encodeURIComponent(settlementId)}`);
};

export const confirmMollieBatch = (
    settlementId: string,
    mollieBatchConfirmationRequest: MollieBatchConfirmationRequest
) => {
    return callApi(`/api/batch/mollie/${encodeURIComponent(settlementId)}/confirm`, {
        method: 'POST',
        data: mollieBatchConfirmationRequest,
    });
};
